export default {
  state: {
    // workTypeList:[],
    postTypeList: [],
    normalWorkList: [],
    specialWorkList: [],
    licenseList: []
    // roleList:[]
  },
  getters: {
    // workTypeList: state => state.workTypeList,
    postTypeList: state => state.postTypeList,
    normalWorkList: state => state.normalWorkList,
    specialWorkList: state => state.specialWorkList,
    licenseList: state => state.licenseList
    // roleList: state => state.roleList,
  },
  mutations: {
    // workTypeList(state, data) {
    //     state.workTypeList = data
    // },
    postTypeList (state, data) {
      state.postTypeList = data
    },
    normalWorkList (state, data) {
      state.normalWorkList = data
    },
    specialWorkList (state, data) {
      state.specialWorkList = data
    },
    licenseList (state, data) {
      state.licenseList = data
    }
    // roleList(state, data) {
    //     state.roleList = data
    // },
  },
  actions: {
    // handleWorkTypeList(workTypeList, data) {
    //     workTypeList.commit('workTypeList', data)
    // },
    handlePostTypeList (postTypeList, data) {
      postTypeList.commit('postTypeList', data)
    },
    handleNormalWorkList (normalWorkList, data) {
      normalWorkList.commit('normalWorkList', data)
    },
    handleSpecialWorkList (specialWorkList, data) {
      specialWorkList.commit('specialWorkList', data)
    },
    handleLicenseList (licenseList, data) {
      licenseList.commit('licenseList', data)
    }
    // handleRoleList(roleList, data) {
    //     roleList.commit('roleList', data)
    // },
  }
}
